import { BrowserModule } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PricingModule } from '@ee/common/pricing';
import { ComparisonComponent } from './comparison.component';
import { AttorneyComponent } from './pricing.component';
import { popperVariation, provideTippyConfig, provideTippyLoader } from '@ngneat/helipopper/config';
import { promoteTooltipAboveCdkOverlay } from '@ee/common/utils';

@NgModule({
  declarations: [ComparisonComponent, AttorneyComponent],
  bootstrap: [ComparisonComponent, AttorneyComponent],
  imports: [BrowserModule, BrowserAnimationsModule, CommonModule, PricingModule],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: 'environment', useValue: environment },
    provideHttpClient(withInterceptorsFromDi()),
    provideTippyLoader(() => import('tippy.js')),
    provideTippyConfig({
      // A tooltip anchored inside a CDK overlay renders behind it: since Angular 21 the CDK attaches
      // overlays with popover="manual", putting them in the browser top layer, which no z-index can
      // reach. This promotes such a tooltip into the top layer too. No-op for every other tooltip.
      onMount: promoteTooltipAboveCdkOverlay,
      defaultVariation: 'tooltip',
      variations: {
        tooltip: {
          theme: null,
          arrow: true,
          animation: 'scale',
          trigger: 'mouseenter',
          offset: [0, 5]
        },
        popper: popperVariation
      }
    })
  ]
})
export class AppModule {
  constructor() {}
}
